import moment from 'moment';
import { Page } from '../model/elements';
import { DesignRatingReport, DesignRatingReportResult } from '../model/entities-report';
import { reportApiAxios } from './CustomAxios';

class DesignRatingReportApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        projectId?: string,
        searchText?: string,
    ): Promise<Page<DesignRatingReport>> => {
        const response = await reportApiAxios.get<Page<DesignRatingReport>>('/reports/design-ratings', {
            params: { page, size, sortField, sortOrder, projectId, searchText },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach(this.loadDates);

        return response.data;
    };

    get = async (id: number): Promise<DesignRatingReport> => {
        const response = await reportApiAxios.get<DesignRatingReport>(`/reports/design-ratings/${id}`);
        this.loadDates(response.data);

        return response.data;
    };

    create = async (designRatingReport: DesignRatingReport): Promise<DesignRatingReport> => {
        const response = await reportApiAxios.post<DesignRatingReport>(`/reports/design-ratings`, designRatingReport);
        this.loadDates(response.data);

        return response.data;
    };

    update = async (designRatingReport: DesignRatingReport): Promise<DesignRatingReport> => {
        const response = await reportApiAxios.put<DesignRatingReport>(
            `/reports/design-ratings/${designRatingReport.id}`,
            designRatingReport,
        );
        this.loadDates(response.data);

        return response.data;
    };

    delete = async (id: number): Promise<void> => {
        const response = await reportApiAxios.delete<void>(`/reports/design-ratings/${id}`);

        return response.data;
    };

    build = async (hubId: string, projectId: string, checklistId: string): Promise<DesignRatingReportResult> => {
        const response = await reportApiAxios.get<DesignRatingReportResult>('/reports/design-ratings/results', {
            params: { hubId, projectId, checklistId },
        });

        response.data.siteGeneralData.forEach((i) => {
            i.valueDate = i.valueDate && moment.utc(i.valueDate).local();
        });

        return response.data;
    };

    /**
     * Loads the dates.
     * @param report - the report
     */
    private loadDates(report: DesignRatingReport) {
        report.audit!.created = report.audit!.created && moment.utc(report.audit!.created).local();
        report.audit!.updated = report.audit!.updated && moment.utc(report.audit!.updated).local();
    }
}

const designRatingReportApi: DesignRatingReportApi = new DesignRatingReportApi();
export default designRatingReportApi;
